/* Fransk katalog for locale-invoice-detail-no.js (del 1 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'inv.detail.completion': 'Réalisation',
  'inv.detail.completed': 'Réalisé',
  'inv.detail.notCompleted': 'Non réalisé',
  'inv.detail.paymentStatus': 'Statut de paiement',
  'inv.detail.paid': 'Payé',
  'inv.detail.remaining': 'Restant',
  'inv.detail.registeredPayments': 'Paiements enregistrés',
  'inv.detail.registerPayment': 'Enregistrer un paiement',
  'inv.detail.settlementStatus': 'Règlement',
  'inv.detail.creditOffset': 'Compensé',
  'inv.detail.creditRefunded': 'Remboursé',
  'inv.detail.creditOpen': 'Non remboursé',
  'inv.detail.offsetAgainst': 'Compensé avec {document}',
  'inv.detail.offsetAgainstInvoice': 'Compensé avec la facture',
  'inv.detail.refunded': 'Remboursé',
  'inv.detail.toCredit': 'Dû au client',
  'inv.detail.registeredRefunds': 'Remboursements enregistrés',
  'inv.detail.registerRefund': 'Enregistrer un remboursement',
  'inv.detail.amountTitle': 'Montant',
  'inv.detail.amountHelp': 'Le montant HT, la TVA et le total sont calculés à partir des lignes de facture enregistrées.',
  'inv.detail.net': 'HT',
  'inv.detail.totalAmount': 'Montant total',
  'inv.detail.history': 'Historique',
  'inv.detail.action': 'Action',
  'inv.detail.loadingDoc': 'Chargement du document...',
  'inv.detail.openedFromLink': 'Document ouvert depuis un lien',
  'inv.act.open': 'Ouvrir',
  'inv.act.openHelp': 'Ouvrez le brouillon dans Nouvelle vente pour le modifier et l\'envoyer.',
  'inv.act.send': 'Envoyer',
  'inv.act.sendAgain': 'Renvoyer',
  'inv.act.sendCreditNote': 'Envoyer l\'avoir',
  'inv.act.sendHelp': 'Envoyez le document au client par e-mail via le backend.',
  'inv.act.markDelivered': 'Marquer comme remis',
  'inv.act.markDeliveredHelp': 'À utiliser lorsque le document a été remis au client en dehors de Plumme.',
  'inv.act.view.invoice': 'Voir la facture',
  'inv.act.view.quote': 'Voir le devis',
  'inv.act.view.orderConfirmation': 'Voir la confirmation de commande',
  'inv.act.view.creditNote': 'Voir l\'avoir',
  'inv.act.viewHelp': 'Prévisualisez le document tel que le client le voit.',
  'inv.act.copyLink': 'Copier le lien',
  'inv.act.copyLinkHelp': 'Copiez un lien partageable vers le document.',
  'inv.act.download': 'Télécharger',
  'inv.act.downloadHelp': 'Téléchargez le document au format PDF.',
  'inv.act.packingSlip': 'Créer un bon de livraison',
  'inv.act.packingSlipHelp': 'Créez et téléchargez un bon de livraison pour les marchandises de cette facture.',
  'inv.act.copy': 'Dupliquer',
  'inv.toast.copyOpened': 'La copie est ouverte — enregistrez-la comme brouillon ou créez-la',
  'inv.act.share': 'Partager',
  'inv.act.shareHelp': 'Copiez le lien de partage, téléchargez le PDF ou créez un bon de livraison.',
  'inv.share.title': 'Partager le document',
  'inv.act.convertOffer': 'Créer',
  'inv.act.convertOfferHelp': 'Crée une facture ou une confirmation de commande en brouillon, avec le client et les lignes du devis.',
  'inv.convert.title': 'Créer à partir du devis',
  'inv.convert.invoice': 'Facture',
  'inv.convert.invoiceHelp': 'Délai de paiement habituel. Comptabilisée lors de sa création.',
  'inv.convert.order': 'Confirmation de commande',
  'inv.convert.orderHelp': 'Confirme l\'accord sans facturer. Peut être facturée plus tard.',
  'inv.act.markAccepted': 'Marquer comme accepté',
  'inv.act.markAcceptedHelp': 'À utiliser lorsque le client a accepté le devis oralement, lors d\'une réunion ou par e-mail. L\'acceptation faite par le client lui-même via le lien du devis est enregistrée automatiquement.',
  'inv.act.undoAccepted': 'Retirer l\'acceptation',
  'inv.act.undoAcceptedHelp': 'Annule une acceptation enregistrée ici dans l\'application. Une acceptation effectuée par le client lui-même ne peut pas être retirée.',
  'inv.act.copyHelp': 'Créez une nouvelle facture avec le même contenu que celle-ci.',
  'inv.act.credit': 'Créer un avoir',
  'inv.act.creditHelp': 'Créez un avoir qui compense cette facture.',
  'inv.act.delete': 'Supprimer',
  'inv.act.deleteHelp': 'Supprimez ce brouillon. Action irréversible.',
  'inv.err.actionFailed': 'L\'action n\'a pas pu aboutir.',
  'inv.err.openDoc': 'Impossible d\'ouvrir le document.',
  'inv.err.previewPacking': 'Impossible de prévisualiser le bon de livraison.',
  'inv.err.settleNotConnected': 'Le règlement sans paiement n\'est pas connecté au backend.',
  'inv.err.settleFailed': 'Impossible de régler sans paiement.',
  'inv.err.needEmail': 'Saisissez d\'abord l\'e-mail du destinataire.',
  'inv.err.emailCharset': 'Les adresses e-mail ne peuvent pas contenir æ, ø, å ni d\'autres caractères spéciaux.',
  'inv.err.invalidEmail': 'Cela ne ressemble pas à une adresse e-mail valide.',
  'inv.err.acceptNotConnected': 'L\'acceptation n\'est pas connectée au backend.',
  'inv.err.acceptFailed': 'Impossible de mettre à jour l\'acceptation.',
  'inv.err.convertNotConnected': 'La conversion n\'est pas connectée au backend.',
  'inv.err.convertOpenFailed': 'Le brouillon a été créé, mais n\'a pas pu être ouvert.',
  'inv.err.convertFailed': 'Impossible de créer le document à partir du devis.',
  'inv.err.copyOpenFailed': 'La copie a été créée, mais n\'a pas pu être ouverte.',
  'inv.err.deleteNotConnected': 'La suppression n\'est pas connectée au backend.',
  'inv.err.deleteFailed': 'Impossible de supprimer le brouillon.',
  'inv.toast.onlyDrafts': 'Seuls les brouillons peuvent être supprimés ici',
  'inv.toast.offerAccepted': 'Le devis est marqué comme accepté',
  'inv.toast.offerAcceptanceRemoved': 'L\'acceptation a été retirée',
  'inv.toast.invoiceDraftFromOffer': 'La facture est ouverte — enregistrez-la comme brouillon ou créez-la',
  'inv.toast.orderDraftFromOffer': 'La confirmation de commande est ouverte — enregistrez-la comme brouillon ou créez-la',
  'inv.toast.draftDeleted': 'Brouillon supprimé',
  'inv.pay.settleWithout': 'Réglé sans paiement',
  'inv.pay.saveChange': 'Enregistrer la modification',
  'inv.pay.paidDate': 'Date de paiement',
  'inv.pay.datePh': 'jj.mm.aaaa',
  'inv.pay.registerPaymentTitle': 'Enregistrer un paiement',
  'inv.pay.editPaymentTitle': 'Modifier le paiement',
  'inv.pay.registerRefundTitle': 'Enregistrer un remboursement',
  'inv.pay.editRefundTitle': 'Modifier le remboursement',
  'inv.pay.paidFrom': 'Payé depuis',
  'inv.pay.refundDate': 'Date de remboursement',
  'inv.pay.refundAmount': 'Montant remboursé',
  'inv.pay.remainingNote': 'Restant dû sur la facture : {amount}. Vous pouvez enregistrer un paiement partiel.',
  'inv.pay.refundNote': 'Le client dispose de {amount} sur cet avoir. Vous pouvez enregistrer un remboursement partiel.',
  'inv.pay.refundHelp': 'L\'avoir annule la vente dans tous les cas. N\'enregistrez un remboursement que lorsque le client récupère effectivement de l\'argent.',
  'inv.pay.fee': 'Frais bancaires et de carte',
  'inv.pay.feeAccount': 'Compte de frais',
  'inv.pay.bankAmountIn': 'Montant réellement reçu en banque : {amount}',
  'inv.pay.bankAmountOut': 'Montant réellement payé depuis la banque : {amount}',
  'inv.detail.offsetCustomerCredit': 'Compenser le crédit client',
  'inv.detail.customerCreditOffset': 'Crédit client compensé',
  'inv.detail.customerCreditAllocated': 'Compensé avec une autre facture',
  'inv.detail.relatedRefund': 'Remboursé via l\'avoir associé',
  'inv.toast.customerCreditOffset': 'Le crédit client a été compensé avec la facture',
  'inv.err.noCustomerCredit': 'Aucun avoir client disponible n\'a été trouvé.',
  'inv.err.customerCreditOffsetFailed': 'Impossible de compenser le crédit client.',
  'cust.ledger.creditOffset': 'Crédit client compensé',
  'inv.toast.paymentRegistered': 'Encaissement enregistré',
  'inv.toast.paymentUpdated': 'Paiement mis à jour',
  'inv.toast.refundRegistered': 'Remboursement enregistré',
  'inv.toast.refundUpdated': 'Remboursement mis à jour',
  'inv.err.paymentFailed': 'Impossible d\'enregistrer l\'encaissement.',
  'inv.err.paymentUpdateFailed': 'Impossible de mettre à jour le paiement.',
  'inv.err.refundFailed': 'Impossible d\'enregistrer le remboursement.',
  'inv.err.refundUpdateFailed': 'Impossible de mettre à jour le remboursement.',
  'inv.del.confirm': 'Oui, supprimer le brouillon',
  'inv.del.body': 'Voulez-vous vraiment supprimer ce brouillon pour {customer} ? Cette action est irréversible.',
  'inv.send.body': '{document} de {amount} sera envoyé à {customer} en PDF par e-mail.',
  'inv.send.resendNote': ' Il s\'agit d\'un nouvel envoi d\'un document déjà envoyé.',
  'inv.credit.continue': 'Vers l\'avoir',
  'inv.credit.intro': 'Un avoir compense la facture de {customer}. Choisissez de créditer la totalité de la facture ou seulement une partie.',
  'inv.credit.full': 'Avoir total',
  'inv.credit.partial': 'Avoir partiel',
  'inv.credit.line': 'Ligne',
  'inv.credit.count': 'Quantité',
  'inv.credit.credited': 'À créditer',
  'inv.credit.total': 'Montant de l\'avoir',
  'inv.credit.breakdown': 'HT {net} · TVA {vat}',
  'inv.credit.partialSuffix': ' · avoir partiel',
  'inv.delivery.rowFailed': 'Non distribué',
  'inv.delivery.bannerTitle': '{n} documents ne sont pas parvenus au destinataire',
  'inv.delivery.bannerBody': 'L\'e-mail a été rejeté ou renvoyé : {documents}. Ouvrez le document, corrigez l\'adresse e-mail du client et renvoyez-le.',
  'inv.credit.rest': 'Créditer le reste',
  'inv.credit.alreadyCredited': 'Déjà crédité : {amount}. Vous ne pouvez créditer que le montant restant.',
  'inv.credit.closedLines': '{n} lignes sont entièrement créditées et ne sont pas affichées.',
  'inv.credit.lineAlready': 'crédité {amount}',
  'inv.credit.hasPayments': 'La facture comporte des paiements enregistrés. L\'avoir compense le montant ouvert ; un éventuel remboursement est enregistré séparément.',
  'inv.credit.date': 'Date de l\'avoir',
  'inv.credit.dateHint': 'La date détermine la période comptable et de TVA dans laquelle l\'avoir est comptabilisé.',
  'inv.credit.dateBeforeInvoice': 'La date de l?avoir ne peut pas ?tre ant?rieure ? la date de la facture.',
  'inv.credit.invalidDate': 'Choisissez une date d\'avoir valide.',
  'inv.credit.paidConfirmTitle': 'La facture est payée',
  'inv.credit.paidConfirmBody': 'Cette facture a des paiements enregistrés de {amount}. L\'avoir annule la vente, mais un éventuel remboursement est enregistré séparément. Voulez-vous continuer ?',
  'inv.credit.paidConfirmContinue': 'Oui, poursuivre l\'avoir',
  'inv.bulk.creditDateHint': 'La même date est utilisée pour tous les avoirs. Elle détermine la période comptable et la période de TVA.',
  'inv.bulk.creditDateBeforeInvoices': 'La date ne peut pas ?tre ant?rieure ? la date de facture la plus r?cente de la s?lection.',
  'inv.bulk.creditPaidConfirmBody': '{n} des factures sélectionnées ont des paiements enregistrés. Les avoirs annulent les ventes, mais les éventuels remboursements sont enregistrés séparément. Voulez-vous continuer ?',
  'inv.history.creditPartial': 'Avoir partiel de {amount} · avoir {document}',
  'inv.history.creditFull': 'Avoir de {amount} · avoir {document}',
  'inv.history.creditDraft': 'Avoir {document} créé comme brouillon · {amount}',
  'inv.history.creditNoNumber': 'sans numéro',
  'inv.toast.creditOpened': 'L\'avoir pour {document} est ouvert — indiquez le motif et créez-le',
  'inv.toast.partialCreditOpened': 'L\'avoir partiel pour {document} est ouvert — indiquez le motif et créez-le',
  'inv.bulk.selectAll': 'Tout sélectionner à l\'écran',
  'inv.bulk.selectRow': 'Sélectionner le document. Maj+clic sélectionne la plage.',
  'inv.bulk.selectDocument': 'Sélectionner le document',
  'inv.bulk.selectDocuments': 'Sélectionner les documents',
  'inv.bulk.selectedCount': '{n} sélectionné(s)',
  'inv.bulk.shownCount': '{n} affiché(s) dans la liste',
  'inv.bulk.reset': 'Réinitialiser',
  'inv.bulk.deliver': 'Marquer comme remis',
  'inv.bulk.resend': 'Renvoyer',
  'inv.bulk.reminder': 'Relance',
  'inv.bulk.credit': 'Émettre un avoir',
  'inv.bulk.issue': 'Créer et envoyer',
  'inv.bulk.delete': 'Supprimer',
  'inv.bulk.processing': 'Traitement ...',
  'inv.bulk.document': 'Document',
  'inv.bulk.amount': 'Montant',
  'inv.bulk.more': '+ {n} de plus',
  'inv.bulk.noEmail': 'pas d\'e-mail',
  'inv.bulk.newDueDate': 'nouvelle échéance {date}',
  'inv.bulk.reminderType': 'Type',
  'inv.bulk.reminderNotice': 'Rappel de paiement',
  'inv.bulk.reminderDunning': 'Relance',
  'inv.bulk.reminderDueDays': 'Jours jusqu\'à la nouvelle échéance',
  'inv.bulk.reminderFee': 'Frais de relance',
  'inv.bulk.reminderFeeLocked': 'Des frais ne peuvent être ajoutés que sur une relance.',
  'inv.bulk.delivery': 'Envoyer en tant que',
  'inv.bulk.deliveryPdf': 'Pièce jointe PDF',
  'inv.bulk.deliveryLink': 'Lien',
  'inv.bulk.comment': 'Message au client',
  'inv.bulk.commentHint': 'Apparaît dans l\'e-mail à côté du récapitulatif des montants. La facture elle-même n\'est pas modifiée.',
  'inv.bulk.commentPh': 'Par exemple : Nous constatons que la facture reste impayée. N\'hésitez pas à nous contacter si quelque chose n\'est pas clair.',
  'inv.comment.label': 'Message au client',
  'inv.comment.hint': 'Texte facultatif joint à cet envoi.',
  'inv.comment.placeholder': 'Écrivez un message ...',
  'inv.comment.useSaved': 'Utiliser un message',
  'inv.comment.save': 'Enregistrer le message',
  'inv.comment.update': 'Mettre à jour le message',
  'inv.comment.saveTitle': 'Enregistrer le message',
  'inv.comment.updateTitle': 'Mettre à jour le message',
  'inv.comment.saveAsNew': 'Enregistrer comme nouveau',
  'inv.comment.savedTitle': 'Messages enregistrés',
  'inv.comment.name': 'Nom du message',
  'inv.comment.namePh': 'Par exemple : Rappel amical',
  'inv.comment.nameHint': 'Le nom permet de retrouver le message dans la liste.',
  'inv.comment.needName': 'Donnez d\'abord un nom au message',
  'inv.comment.empty': 'Vous n\'avez encore aucun message enregistré.',
  'inv.comment.use': 'Utiliser',
  'inv.comment.saved': 'Message enregistré',
  'inv.comment.updated': 'Message mis à jour',
  'inv.comment.deleted': 'Message supprimé',
  'inv.comment.saveFailed': 'Impossible d\'enregistrer le message.',
  'inv.comment.deleteFailed': 'Impossible de supprimer le message.',
  'inv.comment.notConnected': 'Les messages ne sont pas connectés au backend.',
  'inv.bulk.mode': 'Que doit-il se passer',
  'inv.bulk.mode.draft': 'Enregistrer comme brouillons',
  'inv.bulk.mode.send': 'Créer et envoyer',
  'inv.bulk.mode.create': 'Créer uniquement',
  'inv.bulk.mode.hint.credit': 'Les avoirs sont placés dans l\'onglet des brouillons. Rien n\'est comptabilisé ni envoyé avant que vous ne les créiez.',
  'inv.bulk.mode.hint.creditSend': 'Les avoirs sont comptabilisés et envoyés immédiatement aux clients. Cette action est irréversible.',
  'inv.bulk.mode.hint.issueSend': 'Les brouillons sont comptabilisés avec un numéro de document et envoyés aux clients par e-mail.',
  'inv.bulk.mode.hint.issue': 'Les brouillons sont comptabilisés avec un numéro de document, mais aucun e-mail n\'est envoyé.',
  'inv.bulk.creditReasonOptional': 'Facultatif tant que l\'avoir reste un brouillon. Le motif doit être renseigné avant qu\'il puisse être comptabilisé.',
  'inv.bulk.creditReasonRequired': 'Obligatoire. Le motif figure sur l\'avoir et justifie l\'annulation de la vente.',
  'inv.bulk.title.deliver': 'Marquer les documents sélectionnés comme remis',
  'inv.bulk.title.send': 'Renvoyer les documents sélectionnés',
  'inv.bulk.title.reminder': 'Envoyer une relance ou un rappel de paiement',
  'inv.bulk.title.credit': 'Émettre un avoir pour les factures sélectionnées',
  'inv.bulk.title.issue': 'Créer les brouillons sélectionnés',
  'inv.bulk.title.delete': 'Supprimer les brouillons sélectionnés',
  'inv.bulk.confirm.deliver': 'Marquer comme remis',
  'inv.bulk.confirm.send': 'Renvoyer',
  'inv.bulk.confirm.reminder': 'Envoyer le suivi',
  'inv.bulk.confirm.credit': 'Créer les avoirs',
  'inv.bulk.confirm.creditSend': 'Créer et envoyer les avoirs',
  'inv.bulk.confirm.issue': 'Créer les documents',
  'inv.bulk.confirm.issueSend': 'Créer et envoyer',
  'inv.bulk.confirm.delete': 'Oui, supprimer les brouillons',
  'inv.bulk.body.deliver': 'Documents qui seront marqués comme remis en dehors de Plumme : {n}. Aucun e-mail n\'est envoyé, et la comptabilité et le paiement restent inchangés.',
  'inv.bulk.body.send': '{n} documents seront envoyés à l\'adresse e-mail enregistrée pour le client.',
  'inv.bulk.body.reminder': '{n} factures échues ou impayées font l\'objet d\'un suivi. La facture d\'origine n\'est pas comptabilisée à nouveau.',
  'inv.bulk.body.credit': '{n} factures font l\'objet d\'un avoir pour le montant restant, un avoir par facture. Les lignes déjà créditées ne sont pas reprises.',
  'inv.bulk.body.creditSend': '{n} factures font l\'objet d\'un avoir pour le montant restant. Les avoirs sont créés, comptabilisés et envoyés au client immédiatement — sans passer par les brouillons.',
  'inv.bulk.body.issue': '{n} brouillons seront créés et comptabilisés, et recevront un numéro de document.',
  'inv.bulk.body.issueSend': '{n} brouillons seront créés, comptabilisés et envoyés au client par e-mail.',
  'inv.bulk.body.delete': '{n} brouillons seront supprimés. Les brouillons ne sont pas comptabilisés, mais la suppression est irréversible.',
  'inv.bulk.skip.deliver': 'Lignes sélectionnées qui sont des brouillons, déjà remises ou envoyées, et qui seront ignorées : {n}.',
  'inv.bulk.skip.send': '{n} documents sélectionnés n\'ont pas d\'e-mail et sont ignorés.',
  'inv.bulk.skip.reminder': '{n} lignes sélectionnées ne peuvent pas être relancées ici ou n\'ont pas d\'e-mail.',
  'inv.bulk.skip.credit': '{n} lignes sélectionnées ne peuvent pas faire l\'objet d\'un avoir ici.',
  'inv.bulk.skip.issue': '{n} brouillons sélectionnés n\'ont pas de client ou de lignes et ne peuvent pas être créés depuis ici.',
  'inv.bulk.skip.noEmail': '{n} des documents n\'ont pas d\'adresse e-mail. Ils sont créés et comptabilisés, mais pas envoyés.',
  'inv.bulk.skip.delete': '{n} lignes sélectionnées ne sont pas des brouillons et ne seront pas supprimées.',
  'inv.bulk.toast.delivered': 'Documents marqués comme remis : {n}',
  'inv.bulk.toast.sent': '{n} documents envoyés',
  'inv.bulk.toast.reminded': '{n} rappels de paiement envoyés',
  'inv.bulk.toast.dunned': '{n} relances envoyées',
  'inv.bulk.toast.credited': '{n} avoirs créés comme brouillons',
  'inv.bulk.toast.creditedSent': '{n} avoirs créés et envoyés',
  'inv.bulk.toast.issued': '{n} documents créés',
  'inv.bulk.toast.issuedSent': '{n} documents créés et envoyés',
  'inv.bulk.toast.deleted': '{n} brouillons supprimés',
  'inv.bulk.toast.notSentSuffix': ', {n} créé(s) sans e-mail',
  'inv.bulk.toast.failedSuffix': ', {n} en échec',
  'inv.bulk.err.failed': 'Impossible de terminer l\'action groupée.',
  'inv.bulk.err.deliverNotConnected': 'Le marquage comme remis n\'est pas connecté au backend.',
  'inv.bulk.err.sendNotConnected': 'L\'envoi n\'est pas connecté au backend.',
  'inv.bulk.err.creditNotConnected': 'L\'émission d\'avoirs n\'est pas connectée au backend.',
  'inv.bulk.err.issueNotConnected': 'La création de brouillons n\'est pas connectée au backend.',
  'inv.packing.preview': 'Aperçu',
  'inv.packing.download': 'Télécharger le bon de livraison',
  'inv.packing.invoiceDate': 'Date de facture',
  'inv.pay.account.1920': 'Compte d\'exploitation - 1920',
  'inv.pay.account.2063': 'Privé - 2063',
  'inv.pay.account.1900': 'Espèces - 1900',
  'inv.report.customer': 'Client',
  'inv.report.product': 'Produit',
  'inv.report.salesCount': 'Nombre de ventes',
  'inv.report.count': 'Quantité',
  'inv.report.exVat': 'HT',
  'inv.report.share': 'Part du total',
  'inv.report.noSales': 'Aucune vente sur la période.',
  'inv.report.noProducts': 'Aucun produit vendu sur la période.',
  'inv.report.openCustomer': 'Ouvrir {name} dans Clients',
  'inv.report.totalCustomers': '({n} clients)',
  'inv.report.totalCustomer': '({n} client)',
  'inv.report.totalProducts': '({n} produits)',
  'inv.report.totalProduct': '({n} produit)',
  'inv.report.total': 'Total',
  'inv.report.tile.sales': 'Ventes',
  'inv.report.tile.activeCustomers': 'Clients actifs',
  'inv.report.tile.newCustomers': 'Nouveaux clients',
  'inv.report.tile.totalCustomers': 'Total clients',
  'inv.report.tile.customerRevenue': 'Chiffre d\'affaires clients',
  'inv.report.tile.totalRevenue': 'Chiffre d\'affaires total',
  'inv.report.tile.soldProducts': 'Produits vendus',
  'inv.report.tile.productTypes': 'Types de produits',
  'inv.report.tile.productRevenue': 'Chiffre d\'affaires produits',
  'inv.report.unknownCustomer': 'Client inconnu',
  'inv.report.unspecifiedSale': 'Vente non spécifiée',
  'inv.report.customerSummaryOne': '{sales} ventes à {customers} client ont été enregistrées sur la période. Les ventes aux clients se sont élevées à {amount}.',
  'inv.report.customerSummaryMany': '{sales} ventes à {customers} clients ont été enregistrées sur la période. Les ventes aux clients se sont élevées à {amount}.',
  'inv.report.productSummaryOne': '{count} produits/lignes de {types} type de produit ont été vendus sur la période, pour un total de {amount}.',
  'inv.report.productSummaryMany': '{count} produits/lignes de {types} types de produits ont été vendus sur la période, pour un total de {amount}.',
  'inv.fallback.noCustomer': 'Sans client',
  'inv.fallback.line': 'Ligne {n}',
  'inv.credit.fallbackDescription': 'Vente selon {document}',
  'inv.credit.dialogTitle': 'Émettre un avoir sur la facture {number}',
  'inv.detail.validUntil': 'Valable jusqu\'au',
  'inv.detail.dueDate': 'Échéance',
  'inv.detail.partiallyPaid': 'Partiellement payée',
  'inv.detail.unpaid': 'Non payée',
  'inv.detail.acceptedManual': 'Accepté le {date} · enregistré dans l\'application',
  'inv.detail.acceptedCustomer': 'Accepté le {date} · par le client',
  'inv.detail.orderSentAt': 'Confirmation de commande envoyée le {date}',
  'inv.detail.paymentFeeBank': 'Frais {fee} · Banque {bank}',
  'inv.detail.deliveryFailureHelp': 'Le document est enregistré, mais le destinataire ne l\'a pas reçu. Corrigez l\'adresse du client et renvoyez-le.',
  'inv.detail.timelineHelp': 'Chronologie établie à partir du statut enregistré du document et des paiements.',
  'inv.history.offerAcceptedManual': 'Devis marqué comme accepté (enregistré dans l\'application)',
  'inv.history.offerAcceptedCustomer': 'Devis accepté par le client',
  'inv.history.orderSent': 'Confirmation de commande envoyée',
  'inv.history.documentSentTo': '{document} envoyé à {recipient}',
  'inv.history.deliveredExternally': 'Remis en dehors de Plumme',
  'inv.history.documentCreated': 'Document créé',
  'inv.packing.intro': 'Définissez la date d\'expédition. La date du jour est sélectionnée par défaut.',
  'inv.packing.shippingDate': 'Date d\'expédition',
  'inv.packing.contents': 'Le bon de livraison affiche les descriptions et quantités des lignes de facture. Les prix, la TVA et les informations de paiement ne sont pas affichés.',
  'inv.packing.title': 'Bon de livraison {number}',
  'inv.err.pdfPreviewNotConnected': 'L\'aperçu PDF n\'est pas connecté au backend.',
  'inv.err.packingNotConnected': 'Le bon de livraison n\'est pas connecté au backend.',
  'inv.err.packingDownloadFailed': 'Impossible de télécharger le bon de livraison.',
  'inv.err.paymentNotConnected': 'Les encaissements ne sont pas connectés au backend.',
  'inv.err.paymentEditNotConnected': 'La modification des paiements n\'est pas connectée au backend.',
  'inv.err.sendNotConnected': 'L\'envoi n\'est pas connecté au backend.',
  'inv.err.sendFailed': 'Impossible d\'envoyer le document.',
  'inv.err.deliverNotConnected': 'Le marquage comme remis n\'est pas connecté au backend.',
  'inv.err.deliverFailed': 'Impossible de marquer le document comme remis.',
  'inv.err.linkNotConnected': 'Le lien de facture n\'est pas connecté au backend.',
  'inv.err.linkFailed': 'Impossible de récupérer le lien de la facture.',
  'inv.err.downloadNotConnected': 'Le téléchargement PDF n\'est pas connecté au backend.',
  'inv.err.downloadFailed': 'Impossible de télécharger le document.',
  'inv.err.copyNotConnected': 'La copie n\'est pas connectée au backend.',
  'inv.err.copyFailed': 'Impossible de copier le document.',
  'inv.err.archiveNotConnected': 'L\'archivage n\'est pas connecté au backend.',
  'inv.err.archiveFailed': 'Impossible de mettre à jour le statut d\'archivage.',
  'inv.err.creditNotConnected': 'L\'émission d\'avoirs n\'est pas connectée au backend.',
  'inv.err.creditFailed': 'Impossible de créer l\'avoir.',
  'inv.toast.packingDownloading': 'Téléchargement du bon de livraison',
  'inv.toast.settledWithoutPayment': 'La facture est soldée sans paiement',
  'inv.toast.sendingBackground': '{document} est envoyé en arrière-plan',
  'inv.toast.documentSent': '{document} envoyé',
  'inv.toast.deliveredExternally': 'Le document est marqué comme remis',
  'inv.toast.readyNoEmail': 'Le document est prêt, mais aucun e-mail n\'a été envoyé.',
  'inv.toast.linkCopied': 'Lien vers {number} copié',
  'inv.toast.documentDownloading': 'Téléchargement du document',
  'inv.toast.archiveRestored': 'Sorti de l\'archive',
  'inv.toast.archived': 'Archivé',
  'inv.toast.creditCreated': '{document} créé pour {number}',
  'inv.act.unarchive': 'Sortir de l\'archive',
  'inv.act.archive': 'Archiver',
  'inv.act.archiveHelp': 'Déplacez le devis ou la confirmation de commande vers l\'archive, ou sortez-le de l\'archive.',
  'inv.convert.alreadyTitle': 'Le devis a déjà été converti en :',
  'inv.convert.duplicateWarning': 'Si vous en créez un autre, veillez vous-même à ce que le client ne soit pas facturé deux fois pour le même travail.',
  'inv.convert.footerHelp': 'Les deux sont créés en brouillon avec le client et les lignes du devis, et s\'ouvrent dans le flux de vente.',
  'inv.send.title': 'Envoyer {document} {number}',
  'inv.deliver.title': 'Marquer comme remis',
  'inv.deliver.body': 'Utilisez cette option lorsque le document a déjà été remis au client par un autre moyen. Aucun e-mail n\'est envoyé depuis Plumme. La comptabilisation, la TVA et le statut de paiement ne changent pas, mais les rappels concernant un document non envoyé s\'arrêtent.',
  'inv.delivery.external': 'Remis en dehors de Plumme',
  'inv.more': 'Plus',
  'inv.err.offerAlreadyConverted': 'Le devis a déjà été converti en ce type de document.',
  'sale.totalDiscount': 'Remise globale',
  'sale.totalDiscountHelp': 'Répartie proportionnellement sur toutes les lignes de produits et enregistrée avec une répartition traçable.',
  'sale.det.currency': 'Devise du document',
  'sale.det.exchangeRate': 'Taux vers {currency}',
  'sale.det.exchangeRateDate': 'Date du taux',
  'sale.det.exchangeRateSource': 'Source du taux',
  'sale.det.exchangeRateSourcePh': 'Par exemple Norges Bank ou un taux convenu',
  'sale.create.needCurrencyEvidence': 'Indiquez un taux positif, une date de taux et une source avant de créer la facture.',
  'sale.preview.accountingAmount': 'Montant comptable : {amount} {currency} · taux {rate}',
  'sale.preview.vatAccountingAmount': 'TVA en {currency} : {amount}',
});
